import React,{useState} from "react";
import { Trans } from "@lingui/macro";
export default () => {
    const [fauctaddress, setFauctaddress] = useState("");
    const [error, setError] = useState(null);
    const [ok, setOk] = useState(null);
    const [load, setLoad] = useState(false);
  const fetchData = async () => {
    try {
      setLoad(true);
      //{ receiver,type}
      setError('');
      setOk('');
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ receiver: fauctaddress, type: 1 }),
      };

      const response = await fetch(
        "https://testchainapi.parrots.network/trans/", // https://testfaucet.parrots.network http://127.0.0.1:7001/trans/
        requestOptions
      );

      const jsonData = await response.json();
      if (jsonData.code==500) {
        setError(jsonData.message);
      } else if (jsonData.code==200) {
        setOk(jsonData.message);
      }
      setLoad(false);
      return jsonData;
    } catch (error) {
      setLoad(false);
      setError(error.message);
      console.error("Error fetching data:", error);
    }
  };

  return (
    <section className="py-14 h-screen w-full bg-blue-600 mx-auto">
      <div className="relative overflow-hidden mx-4 px-4 bg-white  py-14 rounded-2xl  md:px-8 md:mx-8">
        <div className="relative z-10 max-w-xl mx-auto sm:text-center">
          <div className="space-y-3">
            <h3 className="text-3xl  font-bold">
              <Trans>Parrot Test Net Faucet</Trans>
            </h3>
            <p className="text-gray-500 leading-relaxed">
              <Trans>Faucet Desc1</Trans>
            </p>
          
            
          </div>
          <div className="mt-6">
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex items-center justify-center border border-black bg-white rounded-lg p-1 sm:max-w-md sm:mx-auto"
            >
              <input
               onChange={(e) => setFauctaddress(e.target.value)}
                type="text"
      
                placeholder="Enter your Address"
                className="text-gray-500 w-full p-2 outline-none"
              />
              <button onClick={()=>fetchData()}  disabled={load} className="p-2 px-3 disabled:bg-gray-400 rounded-lg font-medium text-white bg-blue-600 hover:bg-blue-500 active:bg-blue-700 duration-150 outline-none shadow-md focus:shadow-none sm:px-4">
                <Trans>Claim</Trans>
              </button>
            </form>
            <p className="mt-3 max-w-lg text-[15px] text-gray-700 sm:mx-auto">
              <Trans>Faucet Desc2</Trans>
              <a className="underline" href="https://parrotairdrop.vercel.app/">
                {" "}
                <Trans>Airdrop</Trans>{" "}
              </a>
            </p>
            <p className="mt-3 max-w-lg text-[15px] text-gray-700 sm:mx-auto">
             Token Address:0x3C86A2C1BcEc87995E7E54887ED67CFfba57C20B
            </p>
           

            {error && (
              <p className="mt-3 max-w-lg text-[15px] text-red-700 sm:mx-auto">
                 {error}
              </p>
            )}
            {ok && (
              <p className="mt-3 max-w-lg text-[15px] text-green-700 sm:mx-auto">
                 {ok}
              </p>
            )}
          </div>
        </div>
        {/* <div className="absolute inset-0 w-full h-full" style={{ background: "linear-gradient(268.24deg, rgba(59, 130, 246, 0.76) 50%, rgba(59, 130, 246, 0.545528) 80.61%, rgba(55, 48, 163, 0) 117.35%)" }}></div> */}
      </div>
    </section>
  );
};
